<template>
  <a href="" class="productDeco" @click.prevent="handleClick">
    <div class="productImg">
      <img v-if="imageUrl" :src="imageUrl" width="100%" height="100%" alt="" />
      <img
        v-else
        src="../../assets/images/temp/default_thumb.png"
        width="100%"
        height="100%"
        alt=""
      />

      <span
        v-show="isShippingProduct || isEventProduct"
        class="badge productBadge"
        :class="
          type === 3
            ? '_isDelivery'
            : isEventProduct
            ? '_isEvent'
            : '_isFunding'
        "
      >
        {{
          type === 3 ? deliveryText : isEventProduct ? raffleText : fundingText
        }}
      </span>
    </div>
    <span class="productName">{{ productName }}</span>
    <span class="productSale" v-if="!isSaleAfter && sale">
      {{
        $t('common.unit_and_value', {
          value: sale.addComma(),
          unit: currencyUnit
        })
      }}
    </span>
    <span class="productPrice">
      {{
        $t('common.unit_and_value', {
          value: price.addComma(),
          unit: currencyUnit
        })
      }}
    </span>
    <span class="productSale" v-if="isSaleAfter && sale">
      {{
        $t('common.unit_and_value', {
          value: sale.addComma(),
          unit: currencyUnit
        })
      }}
    </span>
  </a>
</template>

<script>
import { beforeSendLog } from '@/utils'

export default {
  props: {
    productId: {
      type: Number,
      default: ''
    },
    productName: {
      type: String,
      default: ''
    },
    imageUrl: {
      type: String,
      default: ''
    },
    sale: {
      type: Number,
      default: 0
    },
    price: {
      type: Number,
      default: 0
    },
    isSaleAfter: {
      type: Boolean,
      default: false
    },
    serviceName: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: undefined
    },
    currencyUnit: {
      type: String,
      default: '원'
    }
  },
  computed: {
    url() {
      return `/product/${this.productId}`
    },
    object() {
      switch (this.$router.currentRoute.name) {
        case 'product':
          return 'Best'
        case 'my':
          return 'RecentProduct'
      }
    },
    isShippingProduct() {
      return this.type === 3 || this.type === 4
    },
    isEventProduct() {
      return this.type === 7
    },
    deliveryText() {
      return this.$t('status.product.delivery_product')
    },
    raffleText() {
      return this.$t('status.product.raffle_product')
    },
    fundingText() {
      return this.$t('status.product.funding_product')
    }
  },
  methods: {
    handleClick() {
      beforeSendLog(this.object, {
        ProductId: this.productId,
        ProductType: this.type
      })
      this.$router.push(this.url)
    }
  }
}
</script>

<style lang="scss"></style>
